export const convertToPercentage = (
  value: number,
  precision: number,
): number => {
  if (isNaN(value) || !isFinite(value)) {
    return 0
  }
  return +(+value).toFixed(precision)
}
